const cacheMap = new Map<number, [number, Function[]]>();

/**
 * 创建一个共享的时钟tick，设置间隔，返回一个共享tick下的当前时间，用于同步所有的倒计时
 * @param interval 间隔
 * @returns
 */
export function createTick(interval: number = 1000) {
  const [now, setNow] = createSignal(Date.now());
  createEffect(() => {
    let cache = cacheMap.get(interval);
    if (!cache) {
      const fns: Function[] = [];
      cache = [
        setInterval(() => {
          const now = Date.now();
          for (const fn of fns) {
            fn(now);
          }
        }, interval) as unknown as number,
        fns,
      ];
      cacheMap.set(interval, cache);
    }
    const fns = cache[1];
    fns.push(setNow);
    onCleanup(() => {
      fns.splice(fns.indexOf(setNow), 1);
      if (fns.length === 0) {
        clearInterval(cache[0]);
        cacheMap.delete(interval);
      }
    });
  });

  return now;
}
